export enum DataTableFormMode {
  modal = 'modal',
  page = 'page',
}
